import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetSensor } from 'src/app/models/sensor/getSensor';
import { GetSensorValue } from 'src/app/models/sensor/getSensorValue';
import { GetSensorValues } from 'src/app/models/sensor/getSensorValues';

@Injectable({
  providedIn: 'root'
})
export class SensorService {
  constructor(
    private httpClient: HttpClient
  ) { }

  private POST_ENDPOINT: string = 'Sensor';
  private BASE_URL: string = `${environment.sistemaWebAdmin}`;
  private REQUEST_URL: string = `${this.BASE_URL}/${this.POST_ENDPOINT}`;

  getList(parameters: any): Observable<GetSensor> {
    let httpParams = new HttpParams({
      fromObject: parameters,
    });
    return this.httpClient.get<GetSensor>(`${this.REQUEST_URL}/pag`, { params: httpParams });
  }

  getListAll(idEnterprise:number,idHeadquarter:number): Observable<GetSensor> {
    return this.httpClient.get<GetSensor>(`${this.REQUEST_URL}/enterprise/${idEnterprise}/headquarter/${idHeadquarter}`);
  }

  getListSensorValues(idSensor:number): Observable<GetSensorValues> {
    return this.httpClient.get<GetSensorValues>(`${this.REQUEST_URL}/${idSensor}/values`);
  }

  getSensorValue(idSensor:number,type:string): Observable<GetSensorValue> {
    return this.httpClient.get<GetSensorValue>(`${this.REQUEST_URL}/${idSensor}/type/${type}`);
  }

  create(data: any){
    return this.httpClient.post<any>(`${this.REQUEST_URL}`,data);
  }

  update(data: any){
    return this.httpClient.put<any>(`${this.REQUEST_URL}`,data);
  }

  delete(id: number){
    return this.httpClient.delete<any>(`${this.REQUEST_URL}/` + id);
  }

  createValue(data: any){
    return this.httpClient.post<any>(`${this.REQUEST_URL}/value`,data);
  }

  updateValue(data: any){
    return this.httpClient.put<any>(`${this.REQUEST_URL}/value`,data);
  }

  deleteValue(id: number){
    return this.httpClient.delete<any>(`${this.REQUEST_URL}/value/` + id);
  }
}
